import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Table } from 'foundations-components/transitional/components/Table';
import { useMemo } from 'react';
import { SharedDataTableRow } from './SharedDataTableRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SharedDataTable({
  dataSyncs
}) {
  const groupedDataSyncs = useMemo(() => {
    const groupedDataSyncsDictionary = dataSyncs === null || dataSyncs === void 0 ? void 0 : dataSyncs.reduce((acc, dataSync, dataSyncIndex) => {
      const {
        data,
        sync,
        target,
        description,
        fieldMappings
      } = dataSync;
      // To group into one table row, we need the same left column "target", sync direction, and description
      // There also cannot be any field mappings because those are specific to the "target"
      const key = `${target}-${sync}-${description}-${fieldMappings.length ? dataSyncIndex : ''}`;
      if (acc[key]) {
        acc[key].dataArray.push(data);
      } else {
        acc[key] = {
          target,
          sync,
          description,
          fieldMappings,
          dataArray: [data]
        };
      }
      return acc;
    }, {});
    const groupedDataSyncArray = groupedDataSyncsDictionary ? Object.values(groupedDataSyncsDictionary) : [];

    // Alphabetize by left column "target"
    return groupedDataSyncArray.sort((a, b) => {
      var _a$target;
      return a === null || a === void 0 || (_a$target = a.target) === null || _a$target === void 0 ? void 0 : _a$target.localeCompare(b === null || b === void 0 ? void 0 : b.target);
    });
  }, [dataSyncs]);
  return /*#__PURE__*/_jsxs(Table, {
    condensed: true,
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.functionalityCard.tabs.sharedData.table.header.dataSource"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(Flex, {
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.functionalityCard.tabs.sharedData.table.header.syncDirection"
            })
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(Flex, {
            paddingInlineStart: "1500",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.functionalityCard.tabs.sharedData.table.header.inHubSpot"
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: groupedDataSyncs && groupedDataSyncs.map((groupedDataSync, index) => /*#__PURE__*/_jsx(SharedDataTableRow, {
        groupedDataSync: groupedDataSync,
        index: index
      }, index))
    })]
  });
}